export default __webpack_public_path__ + "static/socar-logo-617b4ac7432faecdea2405e9d5889050.png";